import { Alert, Box } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

import {
  ConfirmationDialog,
  CustomButton,
  FormTitleBox,
  InfoTooltip,
  PaginationTable,
} from '../../common/components';
import ProviderDrawer from './components/ProviderDrawer';
import ProvidersDataTable from './components/ProvidersDataTable';
import { PROVIDER_TEXTS as TEXTS } from './constants/providersConstants';
import { useProvidersPage } from './hooks/useProvidersPage';

/** Stock y compras | Proveedores: ABM de proveedores de materiales. */
const Providers = () => {
  const {
    cancelRemove,
    changeField,
    clearError,
    closeDrawer,
    confirmRemove,
    departments,
    districts,
    drawerOpen,
    error,
    errors,
    form,
    handlePageChange,
    handleSearch,
    isLoading,
    isRemoving,
    isSaving,
    loadError,
    openCreate,
    openEdit,
    page,
    rowsPerPage,
    onRowsPerPageChange,
    providerToRemove,
    provinces,
    refetch,
    requestRemove,
    rows,
    save,
    search,
    sort,
    sortTable,
    totalCount,
  } = useProvidersPage();

  return (
    <Box>
      <FormTitleBox
        title={TEXTS.title}
        showButton
        buttonText={TEXTS.add}
        buttonIcon={AddIcon}
        onButtonClick={openCreate}
        showSearch
        searchLabel={TEXTS.search}
        searchValue={search}
        onSearchChange={handleSearch}
        searchSize="medium"
      >
        <InfoTooltip lines={[TEXTS.info]} />
      </FormTitleBox>

      {loadError && (
        <Alert
          severity="error"
          action={(
            <CustomButton variant="outlined" size="small" onClick={() => refetch()}>
              {TEXTS.retry}
            </CustomButton>
          )}
        >
          {loadError}
        </Alert>
      )}
      {error && !drawerOpen && (
        <Alert severity="error" onClose={clearError}>
          {error}
        </Alert>
      )}

      <ProvidersDataTable
        providers={rows}
        isLoading={isLoading}
        sort={sort}
        onSort={sortTable}
        onEdit={openEdit}
        onRemove={requestRemove}
      />

      {totalCount > 0 && (
        <PaginationTable
          page={page}
          totalPages={Math.max(1, Math.ceil(totalCount / rowsPerPage))}
          totalCount={totalCount}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={onRowsPerPageChange}
          onPageChange={handlePageChange}
        />
      )}

      <ProviderDrawer
        open={drawerOpen}
        form={form}
        errors={errors}
        error={error}
        provinces={provinces}
        departments={departments}
        districts={districts}
        isSaving={isSaving}
        onChange={changeField}
        onClose={closeDrawer}
        onSave={save}
      />

      <ConfirmationDialog
        open={Boolean(providerToRemove)}
        onClose={cancelRemove}
        onConfirm={confirmRemove}
        title={TEXTS.confirmTitle}
        message={TEXTS.confirmMessage(providerToRemove)}
        confirmText={TEXTS.confirmText}
        confirmVariant="base"
        isLoading={isRemoving}
      />
    </Box>
  );
};

export default Providers;
